import { useQuery } from "@apollo/client";
import { useHomepageSsr } from "@/providers/HomepageSsrProvider";
import { GetBootcampV2Document } from "../graphql/getBootcampV2.generated";

export const useBootcampV2 = (bootcampId: string) => {
  const { bootcamp: ssrBootcamp, isSsrBootcamp } = useHomepageSsr();
  const hasMatchingServerResult = Boolean(
    bootcampId &&
      isSsrBootcamp &&
      ssrBootcamp?.resolved &&
      ssrBootcamp.requestedId === bootcampId
  );
  const { data, loading, error } = useQuery(GetBootcampV2Document, {
    variables: { id: bootcampId },
    skip: hasMatchingServerResult,
    fetchPolicy: "network-only",
  });

  const bootcamp =
    data !== undefined
      ? data.bootcampV2 ?? null
      : hasMatchingServerResult
      ? ssrBootcamp?.bootcamp ?? null
      : null;

  return {
    isLoading: hasMatchingServerResult ? false : loading,
    error,
    bootcamp,
  };
};
